var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BaseDomain } from 'core/domain/common';
var Graph = /** @class */ (function (_super) {
    __extends(Graph, _super);
    function Graph(
    /**
     * Left node of graph
     *
     * @type {string}
     * @memberof Graph
     */
    leftNode, 
    /**
     * Graph relationship type
     *
     * @type {number}
     * @memberof Graph
     */
    edgeType, 
    /**
     * Right node of graph
     *
     * @type {string}
     * @memberof Graph
     */
    rightNode, 
    /**
     * Graph left node metadata
     *
     * @memberof Graph
     */
    LeftMetadata, 
    /**
     * Graph right node metadata
     *
     * @memberof Graph
     */
    rightMetadata, 
    /**
     * Graph metadata
     *
     * @type {string}
     * @memberof Graph
     */
    graphMetadata, 
    /**
     * Graph node identifier
     *
     * @type {string}
     * @memberof Graph
     */
    nodeId) {
        var _this = _super.call(this) || this;
        _this.leftNode = leftNode;
        _this.edgeType = edgeType;
        _this.rightNode = rightNode;
        _this.LeftMetadata = LeftMetadata;
        _this.rightMetadata = rightMetadata;
        _this.graphMetadata = graphMetadata;
        _this.nodeId = nodeId;
        return _this;
    }
    return Graph;
}(BaseDomain));
export { Graph };



//////////////////
// WEBPACK FOOTER
// ./src/core/domain/graphs/graph.ts
// module id = 662
// module chunks = 50